import _ from 'lodash';

import { StatusesConfig } from './constants';

export const getStatusById = (id) => _.find(StatusesConfig, (status) => status.id === id);
